import ButtonSize from '@/Enums/ButtonSize.enum';
import { getDownloadButtonSizeSx } from '@/helpers/buttons';
import { FileDownloadOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useMemo } from 'react';

interface IProps {
  onClick: () => void;
  size?: ButtonSize;
  disabled?: boolean;
  className?: string;
}

export const DownloadButton = ({ onClick, size = ButtonSize.Other, disabled, className }: IProps) => {
  const { iconSx, buttonSx } = useMemo(() => getDownloadButtonSizeSx(size), [size]);
  return (
    <Button
      onClick={onClick}
      variant='outlined'
      sx={{
        ...buttonSx,
        minWidth: 'unset',
        displayPrint: 'none',
      }}
      disabled={disabled}
      className={className}
    >
      <FileDownloadOutlined sx={iconSx} titleAccess='download' />
    </Button>
  );
};
